import type { MerchantSession, ValidateMerchantResponse } from 'types';

// В completeMerchantValidation должна уйти сама merchant session:
// если передать обёртку { data }, Safari молча закрывает платёжный шит
const getMerchantSession = (response: ValidateMerchantResponse): MerchantSession => {
  const merchantSession =
    response && 'merchantSessionIdentifier' in response ? response : response?.data;

  if (!merchantSession?.merchantSessionIdentifier) {
    throw new Error('Invalid merchant session response');
  }

  return merchantSession;
};

export { getMerchantSession };
